import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  className?: string;
};

/** Условное изображение ленты реплик в превью раскладки */
export const SkeletonDialog: FC<Props> = ({ className }) => (
  <div className={cn('flex flex-col gap-0.5 w-12 h-full overflow-hidden grow-0', className)}>
    {Array(10).fill(
      <>
        <Skeleton className={'w-7/10 h-2 shrink-0 bg-primary ml-auto '} />
        <Skeleton className={'w-9/10 h-3 shrink-0 mr-auto'} />
        <Skeleton className={'w-4/10 h-1 shrink-0 bg-primary ml-auto'} />
        <Skeleton className={'w-9/10 h-3 shrink-0 mr-auto'} />
      </>,
    )}
  </div>
);
